import styled from 'styled-components'

import ContentBlock from '~/components/content-block'
import { font } from '~/styles/utils'

export const Title = styled.div`
  ${font('bold')};
  text-transform: uppercase;
`

export const Body = styled(ContentBlock)`
  margin-top: 12px;

  a {
    text-decoration: underline;
    text-transform: capitalize;
  }
`
